import box from '~/assets/icons/box_4.svg';
import calendar from '~/assets/icons/calendar.svg';
import cash from '~/assets/icons/cash.svg';
import company from '~/assets/icons/company.svg';
import rank from '~/assets/icons/rank.svg';
import { CurrencyIcon } from '~/components/collections';
import { SectionHeading } from '~/components/ui/SectionHeading';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { AppTruckJobActiveContract } from '../AppTruckJobActiveContract';
import { AppTruckJobCompanyProgress } from '../AppTruckJobCompanyProgress';
import { AppTruckJobMyLevel } from '../AppTruckJobMyLevel';
import {
	StyledActiveOrderContainer,
	StyledCompaniesGrid,
	StyledContainer,
	StyledHeader,
	StyledHeadTitleContainer,
	StyledProgressContainer,
	StyledProgressHeadingContainer,
	StyledStatIconContainer,
	StyledStatInfoTextContainer,
	StyledStatInfoValue,
	StyledStatItem,
	StyledStatsContainer,
} from './AppTruckJobMyProgress.styled';

const AppTruckJobMyProgress = () => {
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	return (
		<StyledContainer>
			<StyledHeader>
				<StyledHeadTitleContainer>
					<img src={rank} />
					<Text>Мой прогресс</Text>
				</StyledHeadTitleContainer>
			</StyledHeader>
			<StyledActiveOrderContainer>
				<AppTruckJobMyLevel />
				<AppTruckJobActiveContract state="tags" />
			</StyledActiveOrderContainer>
			<StyledStatsContainer>
				<StyledStatItem>
					<StyledStatIconContainer>
						<img src={cash} />
					</StyledStatIconContainer>
					<StyledStatInfoTextContainer>
						<Text>Общий заработок</Text>
						<StyledStatInfoValue>
							<CurrencyIcon icon={rubleIcon} size={10} />
							<Text>7 777 714 000</Text>
						</StyledStatInfoValue>
					</StyledStatInfoTextContainer>
				</StyledStatItem>
				<StyledStatItem>
					<StyledStatIconContainer>
						<img src={calendar} />
					</StyledStatIconContainer>
					<StyledStatInfoTextContainer>
						<Text>Заработок за смену</Text>
						<StyledStatInfoValue>
							<CurrencyIcon icon={rubleIcon} size={10} />
							<Text>7 777 714 000</Text>
						</StyledStatInfoValue>
					</StyledStatInfoTextContainer>
				</StyledStatItem>
				<StyledStatItem>
					<StyledStatIconContainer>
						<img src={box} />
					</StyledStatIconContainer>
					<StyledStatInfoTextContainer>
						<Text>Кол-во доставок</Text>
						<StyledStatInfoValue>
							<Text>7 777 714 000</Text>
						</StyledStatInfoValue>
					</StyledStatInfoTextContainer>
				</StyledStatItem>
			</StyledStatsContainer>
			<StyledProgressContainer>
				<StyledProgressHeadingContainer>
					<SectionHeading
						text={'Прогресс компаний'}
						icon={company}
						gap={10}
						iconSize={20}
						fontSize={16}
					/>
					<Text style={{ fontSize: 16, color: '#ffffff' }}>
						<span style={{ opacity: 0.5 }}>Доступные компании</span>{' '}
						<span style={{ fontWeight: 500, color: '#1AB248' }}>12</span>{' '}
						<span style={{ fontSize: 14, opacity: 0.25 }}>/ 20</span>
					</Text>
				</StyledProgressHeadingContainer>
				<StyledCompaniesGrid>
					{Array.from({ length: 10 }).map((_, index) => (
						<AppTruckJobCompanyProgress key={index} />
					))}
				</StyledCompaniesGrid>
			</StyledProgressContainer>
		</StyledContainer>
	);
};

export { AppTruckJobMyProgress };
